import React from 'react';

import { 
    Grid, 
 
    makeStyles } from '@material-ui/core'; 
    //import FondoImagenes from '/static/imagen/fondo.jpg';

import Grafico2Modal from '../Graficos/Grafico2Modal';


    const useStyles = makeStyles((theme) => ({ 
        tituloTable: {

           backgroundColor: theme.palette.primary.main, 
           minWidth: 200,
           color: 'white',
           textAlign: 'center',
           padding: '20px',
           fontWeight: '250',
           fontSize : '35px'
        },  
        
        TituloIdentificacion: {

            backgroundColor: theme.palette.primary.main, 
            backgroundImage : `url(${process.env.PUBLIC_URL +'/static/imagen/fondo.jpg'})`,
            minWidth: 200,
            color: 'black',
            textAlign: 'left',
            padding: '15px',
            fontWeight: '450',
            fontSize : '18px',
            height: 'auto',
            alignContent: 'center',               
         },
        
    
        FondoTable :{
           
            backgroundColor: theme.palette.greyFondo.main
        }, 

     fondoTituloIndicadores: {

      backgroundColor: theme.palette.fondotitulos.main,
      minWidth: 200,
      color: '#171717',
      textAlign: 'center',
      padding: '15px',
      fontWeight: '250',
      fontSize : '18px',
      height: 'auto',
      alignContent: 'center',               
   },
   sizeIcono : {
    
      height: '50px',
      width: '50px'
  }
    
}))



const AsignacionGraficos = () => {
    const classes = useStyles();


    return (
        <>
  
                 <div className={classes.TituloIdentificacion}> ANÁLISIS DE RIESGO </div>
                  
                <Grid  container direction="row"  spacing={2}>  
             

            <Grid item xs={12} sm={12} xl={12} md={12} lg={12} >
             
                <div className={classes.fondoTituloIndicadores}>Período de Morosidad</div>
                 
                          
                    <Grafico2Modal />
               
                
            </Grid>
            </Grid>
   
              
           
        </>
    )
}

export default AsignacionGraficos
